module.exports = __webpack_public_path__ + "img/1.59f7b911.jpg";